<template>
  <div class="box">
    <!-- 标题box -->
    <div class="box_title">{{ title }}</div>
    <!-- 地址列表 -->
    <div class="mainBox">
      <div class="mainBox_article">
        <h1 style="text-align: center">
          <span style="font-family: 宋体"
            >鲜丰汇平台销售服务协议（网站电子协议）</span
          >
        </h1>
        <p>
          <span style="font-family: 宋体">“鲜丰汇”平台</span
          ><span style="font-family: 宋体">温馨提示</span
          ><span style="font-family: 宋体"
            >，请采购人仔细阅读本协议，一旦您确认本协议则视为您同意本协议全部内容，“鲜丰汇”平台将依据协议确认的权利和义务为您提供销售服务</span
          ><span style="font-family: 宋体">：</span>
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第一条 </strong
          ><strong><span style="font-family: 宋体">采购人信息</span></strong>
        </p>
        <p style="margin-left: 0; text-indent: 0">
          1、<span style="font-family: 宋体"
            >“鲜丰汇”平台是江苏省供销合作总社、苏合集团旗下江苏省苏合农副产品展示展销中心有限公司负责研发、运营的单位食堂、工会福利集采平台。采购人指在“鲜丰汇”平台进行单位食堂、工会福利购买的政府财政预算单位、企事业单位或个人。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          2、<span style="font-family: 宋体"
            >采购人享有本网站相关服务、下单购物等相应的权利和行为能力，对于采购人提供的资料的原因引起的相关责任和后果均由采购人自行承担。除非双方另有约定，采购人不得将其账户租、借或转让第三方使用，否则采购人应承担由此产生的全部责任。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          3、<span style="font-family: 宋体"
            >采购人可以根据本网站规则更改密码。采购人应妥善保管、使用其账户及密码信息，并对账户项下发生的所有行为负责。采购人若发现任何非法使用其采购人账号或存在安全漏洞的情况，应立即通知本网站。</span
          ><br />
          3<span style="font-family: 宋体"
            >、采购人在此同意，本网站有权以通过邮件、短信、电话等形式向在本网站注册、购物采购人、收货人发送订单信息、促销活动等通知或公告。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第二条 </strong><strong>&nbsp;</strong
          ><strong
            ><span style="font-family: 宋体">采购人权利和义务</span></strong
          >
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、采购人有权根据本协议及本网站上发布的相关规则享受本网站提供的各种服务。</span
          >
          <br />
          2<span style="font-family: 宋体"
            >、采购人在使用本网站的过程中应遵守诚实信用原则，不扰乱网上交易的正常秩序。</span
          ><br />
          3<span style="font-family: 宋体"
            >、采购人有权就商家或商品进行评论或讨论，并拥有发表、删除自己账户下所有评论的权利。</span
          >
          <br />
          4<span style="font-family: 宋体"
            >、采购人在使用本网站的过程中，应严格遵守国家宪法、法律法规、相关规章制度、本协议及本网站相关规则的要求，采购人的相关言论、行为不得违背社会公序良俗，不得损害他人的合法权益。因采购人在本网站发表的言论或相关行为侵犯他人合法权益的，采购人须承担相应法律责任。</span
          ><br />
          5<span style="font-family: 宋体"
            >、鉴于本网站上的商品的名称、价格、数量、型号、规格、尺寸、库存数量等信息具有变动性，采购人下订单时应仔细确认相关信息并承担相应的法律后果，本网站对于前述信息变动而产生的任何不利于采购人的后果不承担任何责任。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第三条 </strong><strong>&nbsp;</strong
          ><strong
            ><span style="font-family: 宋体">网站权利和义务</span></strong
          >
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、本网站应确保网上交易平台的正常运行，保障采购人网上交易活动的顺利进行。</span
          ><br />
          2<span style="font-family: 宋体"
            >、本网站保留删除站内各类不符合国家宪法、法律法规、相关规章制度、本协议、本网站相关规则或不真实的内容而无须通知采购人的权利。</span
          ><br />
          3<span style="font-family: 宋体"
            >、对于采购人的违法、违规或违约行为，本网站有权作出独立判断并有权采取暂停或关闭采购人帐号等措施。</span
          >
          <br />
          4<span style="font-family: 宋体"
            >、未经本网站同意，采购人不得在本网站上发布任何形式的广告。</span
          ><br />
          5<span style="font-family: 宋体"
            >、本网站有权制定、发布、更新交易平台服务规则，以更好的规范平台和采购人之间的商品交易行为，并对该等规则享有修改权、解释权。</span
          ><br />
          6<span style="font-family: 宋体"
            >、如采购人提供的资料包含有不正确或虚假的信息，本网站保留终止采购人使用网络服务资格的权利。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第四条 </strong><strong>&nbsp;</strong
          ><strong><span style="font-family: 宋体">平台订单服务</span></strong>
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、采购人在此同意：本网站上展示的商品、价格等信息仅是要约邀请，采购人下订单时应填写欲购买的商品、数量、价款、规格、型号、收货人、联系方式、收货地址等内容，系统生成的订单仅是采购人向采购人发出的要约，只有在平台将采购人订单中订购的商品确认并出库时，方视为采购人与平台之间就实际发出的商品建立了协议关系。</span
          ><br />
          2<span style="font-family: 宋体"
            >、收货人与实际注册采购人不一致的，采购人应对收货人的行为及表示产生的法律后果承担连带责任。</span
          >
          <br />
          3<span style="font-family: 宋体"
            >、采购人可以在下列情况下，取消订单：</span
          >
          <br />
          3.1<span style="font-family: 宋体">采购人与平台协商达成一致的；</span>
          <br />
          3.2<span style="font-family: 宋体"
            >在平台对采购人的订单做出承诺之前；</span
          ><br />
          3.3<span style="font-family: 宋体"
            >本网站上公布的商品价格、规格、型号、库存发生变化或出现展示信息错误，采购人在平台发货之前通知平台的。</span
          ><br />
          4<span style="font-family: 宋体"
            >、平台可以在下列情况下，取消采购人订单或取消部分订单：</span
          >
          <br />
          4.1<span style="font-family: 宋体">采购人与平台协商达成一致的；</span
          ><br />
          4.2<span style="font-family: 宋体"
            >采购人订单信息明显错误或采购人订购数量超出平台库存数量的。</span
          ><br />
          5<span style="font-family: 宋体"
            >、本网站有权在发现网站上展示的商品缺货、商品信息明显错误或采购人订单信息明显错误的情况下单方面取消订单而不需向采购人承担任何责任，在此情况下，本网站将尽力协调以满足采购人需求。同时，本网站保留对商品订购数量的限制权。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第五条 </strong
          ><strong
            ><span style="font-family: 宋体">商品质量、包装和运输</span></strong
          >
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、交易中，供应商应保证其提供的商品与商品包装或商品本身商标标示的质量标准相符，或者与商品说明、实物样品等方式体现的质量状况相符。</span
          >
        </p>
        <p>
          2<span style="font-family: 宋体"
            >、采购人有权要求供应商提供商品有效的质量证明材料。</span
          >
        </p>
        <p>
          3<span style="font-family: 宋体"
            >、供应商承诺，所提供的商品必须符合国家法律、法规、各行政部门的规章制度、地方法规规章、行政命令、各行业规范的有关规定以及现行国家相关标准或现行相关行业质量标准。</span
          >
        </p>
        <p>
          4<span style="font-family: 宋体"
            >、在约定期限内如因商品质量问题，导致采购人出现退换货，期间产生的费用由供应商承担。</span
          >
        </p>
        <p>
          5<span style="font-family: 宋体"
            >、包装应符合商品运输、装卸的需要，因包装不当引起的商品破损、变质等损失，由供应商承担。</span
          >
        </p>
        <p>
          6<span style="font-family: 宋体"
            >、供应商物流配送的商品，应按照商品的特点以及采购人的要求，双方协商选择合适的运输方式，如果因运输途中造成商品破损、变质、丢失等损失，由供应商承担；采购人自提的商品，供应商应按照采购人的要求将商品送至约定的自提点，采购人在双方约定时间内完成提货与签收。</span
          >
        </p>
        <p>
          7<span style="font-family: 宋体"
            >、供应商承诺违反以下约定即可视为交付的商品不符合协议及交收单的约定：</span
          >
        </p>
        <p>
          <span style="font-family: 宋体">（</span>1<span
            style="font-family: 宋体"
            >）商品的包装符合国家和地方的相关规定，由采供双方协商确认。</span
          >
        </p>
        <p>
          <span style="font-family: 宋体">（</span>2<span
            style="font-family: 宋体"
            >）商品及商品的包装内不含违反国家法律法规的印刷品、音响制品等物品。商品包装、造型、装饰及外观上的文字及图案等不得违反法律规定，否则因此引起的相关责任</span
          >
          <span style="font-family: 宋体">由供应商承担。</span>
        </p>
        <p>
          <span style="font-family: 宋体">（</span>3<span
            style="font-family: 宋体"
            >）商品的包装不得侵犯任何第三方的权利包括但不限于知识产权。</span
          >
        </p>
        <p>
          8<span style="font-family: 宋体"
            >、本网站为采购人与供应商的撮合交易平台，本网站所供应之商品由供应商直接负责商品发货、配送、售后服务。如因供应商的产品配送、产品质量、食品安全、商品实物与宣传描述不符等原因引发侵犯采购人权益的问题，由供应商配合相关职能部门处理并最终承担全部责任，网站将积极配合采购人及相关职能部门处理上述相应问题。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第六条 </strong
          ><strong
            ><span style="font-family: 宋体">商品交付、检验和退货</span></strong
          >
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、供应商应按双方约定的品牌规格、价格、数量、交付时间、交付地点，向采购人交付商品。</span
          >
        </p>
        <p>
          2<span style="font-family: 宋体"
            >、供应商应在商品到达之前向采购人发出通知以便其作相应的接货准备。</span
          >
        </p>
        <p>
          3<span style="font-family: 宋体"
            >、供应商将商品运送到指定交货地后，采购人应按照约定在一个工作日内进行验收，在验收无误后完成平台确认收货操作，并承认平台在根据物流信息确认到货后的</span
          >3<span style="font-family: 宋体">个工作日后自动确认收货。</span>
        </p>
        <p>
          4<span style="font-family: 宋体"
            >、如果采购人验收时发现供应商提供的商品不符合约定，采购人应在约定期限内将商品不符合约定的情形通过线上提起异议申请售后或线下与供应商协商解决，供应商应在约定期限内完成异议处理。</span
          >
        </p>
        <p>
          5<span style="font-family: 宋体"
            >、因以下情况造成商品无法配送或出现任何不合理的延迟等，供应商不承担相应责任：</span
          >
        </p>
        <p>
          5.1<span style="font-family: 宋体"
            >采购人提供的订单上的信息错误、地址不详细等原因导致的；</span
          >
        </p>
        <p>
          5.2<span style="font-family: 宋体"
            >货物送达后无人签收，导致无法配送或延迟配送的；</span
          >
        </p>
        <p>5.3<span style="font-family: 宋体">不可抗力因素导致的。</span></p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第七条 </strong
          ><strong
            ><span style="font-family: 宋体">支付结算及其他约定</span></strong
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          1、<span style="font-family: 宋体"
            >采供双方本着平等互利、诚实信用的原则，除特殊约定以外，授信额度内的交易，平台应提供订单全额发票，采购人凭票付款。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          2、<span style="font-family: 宋体">采购人确认收货</span>2<span
            style="font-family: 宋体"
            >个工作日内，平台开具发票给采购人。采购人在收到发票后</span
          >10<span style="font-family: 宋体">个工作日内安排完成货款支付。</span>
        </p>
        <p style="margin-left: 0; text-indent: 0">
          3、<span style="font-family: 宋体"
            >采购人确认签字的商品配送物流单据或采购人在网站上点击“确认收货”将作为确认送货品种和数量的依据，订单数量在实际交货时出现的货物溢短情况由采供双方协商解决。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          4、<span style="font-family: 宋体"
            >质量标准：买卖标的商品质量应执行国家法规、行业标准及平台约定的标准。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第八条 </strong
          ><strong
            ><span style="font-family: 宋体">商品所有权及风险转移</span></strong
          >
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、除本协议另有约定或双方补充协议确认外，商品所有权在售出并交付采购人签收前的所有权归属供应商所有，采购人签收后归属采购人所有。但若商品签收后采购人可提供真实、充分的证据，证明商品质量存在问题而要求退换货的，该商品所有权并不发生转移仍由供应商所有。</span
          >
        </p>
        <p>
          2<span style="font-family: 宋体"
            >、由供应商负责配送的，商品在运输途中毁、损、灭、失等风险由供应商承担，若造成损失的，由供应商自行向第三方配送公司追责，采购人予以协助。</span
          >
        </p>
        <p>
          3<span style="font-family: 宋体">、由采购人自提的</span>,<span
            style="font-family: 宋体"
            >商品在运输途中毁、损、灭、失等风险由采购人承担。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第九条 </strong
          ><strong
            ><span style="font-family: 宋体">违约责任及解除条款</span></strong
          >
        </p>
        <p>1<span style="font-family: 宋体">、供应商违约责任</span></p>
        <p>
          <span style="font-family: 宋体">（</span>1<span
            style="font-family: 宋体"
            >）如果供应商不能在约定的交货期内履行交货义务（包括但不限于交货不符采购人拒收或退换货导致的延迟），供应商应提前</span
          >
          3
          <span style="font-family: 宋体"
            >个工作日同采购人重新确认交货信息。因物流、天气等不可抗力的因素，供应商不承担违约责任。</span
          >
        </p>
        <p>
          <span style="font-family: 宋体">（</span>2<span
            style="font-family: 宋体"
            >）商品错发到货地点或接货人而导致的一切损失由供应商承担，经协商后消单、补发或转运。供应商未经采购人同意，单方面改变运输路线和运输工具的，应当承担采购人因此所受的损失。</span
          >
        </p>
        <p>
          <span style="font-family: 宋体">（</span>3<span
            style="font-family: 宋体"
            >）供应商未按协议约定时间完成备货而导致采购人无法按期自提的，由供应商承担由此造成的损失。</span
          >
        </p>
        <p>2<span style="font-family: 宋体">、采购人的违约责任：</span></p>
        <p>
          <span style="font-family: 宋体">（</span>1<span
            style="font-family: 宋体"
            >）采购人中途退货，采购人应按照双方协商一致的违约金额进行偿付。</span
          >
        </p>
        <p>
          <span style="font-family: 宋体">（</span>2<span
            style="font-family: 宋体"
            >）采购人自提商品未在协议规定的日期内完成提货的，应按照双方协商一致的金额向供应商偿付逾期提货的违约金，并承担供应商实际支付的代为保管、保养的费用。</span
          >
        </p>
        <p>
          <span style="font-family: 宋体">（</span>3<span
            style="font-family: 宋体"
            >）采购人违反协议规定拒绝收货的，应当承担由此造成的损失。</span
          >
        </p>
        <p>
          <span style="font-family: 宋体">（</span>4<span
            style="font-family: 宋体"
            >）采购人如错填到货地点或接货人，应承担供应商因此所受的损失。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第十条 </strong
          ><strong><span style="font-family: 宋体">争议解决方式</span></strong>
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、采购人在验收中，如果发现商品的品种、规格、质量不合规定，应举证，并向供应商提出异议，否则视为所交商品符合协议规定。</span
          >
        </p>
        <p>
          2<span style="font-family: 宋体"
            >、采购人因保管不善等造成商品质量下降的，不得提出异议。</span
          >
        </p>
        <p>
          3<span style="font-family: 宋体"
            >、平台在接到采购人书面异议后，应安排供应商与采购人协商，在双方协商一致的期限内负责处理，否则，视为同意采购人提出的异议和处理意见。</span
          >
        </p>
        <p>
          4<span style="font-family: 宋体"
            >、本协议的订立、执行和解释及争议的解决均应适用中国法律。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第十一条 </strong
          ><strong
            ><span style="font-family: 宋体">知识产权和保密</span></strong
          >
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、本协议签订及履行过程中采供双方涉及到的信息应给予严格保密，不得泄露给任何第三人。</span
          >
        </p>
        <p>
          2<span style="font-family: 宋体"
            >、采供双方互相尊重和不侵犯对方的知识产权。</span
          >
        </p>
        <p>
          3<span style="font-family: 宋体"
            >、本条款具有永久效力，不因协议的履行情况等失效。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第十二条 </strong
          ><strong
            ><span style="font-family: 宋体">协议的修改和更新</span></strong
          >
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、本网站有权在其权利范围内根据需要不时地对本协议进行修改、更新而无须事先通知用户或征得用户同意。对于修改、更新后的协议，将在本网站予以通知并替代之前的协议。</span
          >
        </p>
        <p>
          2<span style="font-family: 宋体"
            >、用户应不时关注本网站的协议修改、更新公告，并仔细阅读修改、更新后的协议，如用户不同意相应的修改或更新，则用户有权选择不再继续使用本网站提供的服务，一旦用户继续使用，则视为用户同意本网站所作的相应修改或更新。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第十三条 </strong
          ><strong><span style="font-family: 宋体">协议生效</span></strong>
        </p>
        <p>
          1<span style="font-family: 宋体"
            >、本协议自采购人同意之时起生效。协议有效期内，除经过双方同意，或者另有法定理由，任何一方不得变更或解除协议。</span
          >
        </p>
        <p>
          2<span style="font-family: 宋体"
            >、协议如有未尽事宜，须经双方共同协商，作出补充规定，补充规定与本协议具有同等效力。双方签订确认的补充规定说明是本协议的有效组成部分，具有同等法律效力。</span
          >
        </p>
        <p>
          3<span style="font-family: 宋体"
            >、本协议的成立、有效性、解释、履行、签署、修订和终止以及争议的解决均应适用中华人民共和国大陆地区法律；如无相关法律规定的，则应参照商业惯例和（或）行业惯例。如有未能协商解决的纠纷，任何一方可诉讼至采购人所在地的人民法院提起诉讼解决。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 0">
          <strong>第十四条 </strong
          ><strong><span style="font-family: 宋体">责任限制</span></strong>
        </p>
        <p>
          <span style="font-family: 宋体"
            >如因不可抗力或其他本站无法控制的原因使本网站系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，本网站不承担责任。但是本网站会尽可能地合理地协助处理善后事宜，并努力使用户免受经济损失。</span
          >
        </p>
        <p>&nbsp;</p>
        <p>
          <br />
        </p>
      </div>
      <div class="mainBox_btnBox">
        <el-button
          v-if="!isAgree"
          icon="el-icon-success"
          style="
            width: 161px;
            height: 53px;
            border-color: #f89a00;
            color: #f89a00;
            margin-right: 16px;
          "
          @click="consentAgreement()"
          >同意签署</el-button
        >
        <el-button
          v-else
          icon="el-icon-success"
          style="
            width: 161px;
            height: 53px;
            border: none;
            color: #07811f;
            cursor: auto;
            background-color: #fff;
            margin-right: 16px;
          "
          >已同意签署</el-button
        >
        <a
          :href="downloadUrl"
          download="鲜丰汇平台销售服务协议（网站电子版）.docx"
          style="text-decoration: underline"
        >
          <el-button
            type="primary"
            icon="el-icon-download"
            style="width: 161px; height: 53px"
            >立即下载</el-button
          >
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { doGet } from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
export default {
  props: {
    title: String,
    required: true,
  },
  data() {
    return {
      downloadUrl: "/static/transactionContract.docx",
      isAgree: false,
    };
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    /**
     * 获取是否已同意签署
     */
    getStatus() {
      var that = this;
      doGet(
        httpConfig.myAgreement.getAgreementInfoUrl,
        { peopleId: JSON.parse($cookies.get("peopleId")) },
        function (res) {
          if (res.flag) {
            if (!res.data) {
              that.isAgree = !res.flag;
            } else {
              that.isAgree = res.data.contractStatus == 1;
            }
          }
        }
      );
    },
    /**
     * 同意签署
     */
    consentAgreement() {
      var that = this;
      doGet(
        httpConfig.myAgreement.consentAgreementUrl,
        { peopleId: JSON.parse($cookies.get("peopleId")) },
        function (res) {
          if (res.flag) {
            that.$message.success("同意签署成功！");
            that.getStatus();
          }
        }
      );
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/transactionContract";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/transactionContract.vue